export default __webpack_public_path__ + "static/media/news23111400.2311de67.jpg";